// Based off playground/src/ui-components/Avatar.js
import React from 'react'

import styled from 'styled-components'

import ImageAvatar from '../molecules/AvatarImage'
import Icon from '../atoms/Icon'
import { height, width } from 'styled-system'
import { large, small, xsmall, xxsmall } from '../molecules/AvatarSize'

const planner = props => {
  props.planner ? null : { position: 'relative' }
}

const Wrapper = styled.div`
  ${height} ${width};
  ${large} ${small} ${xsmall} ${xxsmall};
  display: flex;

  ${planner}

  overflow: hidden;
  font-size: 1.25rem;
  flex-shrink: 0;
  align-items: center;
  user-select: none;
  border-radius: 50%;
  justify-content: center;
  border: 1px solid ${props => props.theme.colors[props.borderColor]};
`

Wrapper.defaultProps = {
  height: '80px',
  width: '80px',
}

const Avatar = props => {
  const { icon, large, planner, small, xsmall, xxsmall, context } = props

  let textColor = 'avatarText'
  let borderColor = 'avatarBorder'

  if (context === 'Parent') {
    textColor = 'hullOrange9'
    borderColor = 'hullOrange'
  } else if (context === 'Educator') {
    textColor = 'nebulaBlue9'
    borderColor = 'nebulaBlue'
  }

  return (
    <Wrapper
      large={large}
      small={small}
      xsmall={xsmall}
      xxsmall={xxsmall}
      planner={planner}
      borderColor={borderColor}>
      {icon ? <Icon name={icon} fill={textColor} /> : <ImageAvatar {...props} />}
    </Wrapper>
  )
}

Avatar.displayName = 'Avatar'

export default Avatar
